import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Alert } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { DataSyncStatus } from '../../../types/dataSync'
import { useStyles } from './IngestionStatusBanner.styles'
import { NextCheckLine } from './NextCheckLine'

/**
 * Nothing has ever arrived: a fresh installation, or one whose records were
 * cleared. Not an error — there is simply nothing to plan over yet, which is
 * also why the launch button is disabled and the API answers 409.
 *
 * The last check is what makes the state legible: on its own the sentence
 * leaves the reader unable to tell "it is looking and there is nothing yet"
 * from "it is not looking at all".
 */
export const NeverBanner = ({ sync }: { sync: DataSyncStatus }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Alert type="info" withBorder>
      <span className={classes.icon}>
        <FontAwesomeIcon icon={faCircleInfo} />
      </span>
      <span>
        {t('No data has been synchronized yet')}
        <NextCheckLine nextCheckAt={sync.nextCheckAt} />
      </span>
    </Alert>
  )
}
